import { FormControlLabel, Grid, Switch } from "@mui/material";
import { FastField } from "formik";
import {
  MySelect,
  MySelectTime,
  MyTextField,
  MyTextFieldArea,
  MyTextFieldUploadFile,
  UploadAnhDaiDien,
  UploadMultiFile,
  UploadMultiHinhAnh
} from "../Lib/componentLibrarys";
import Api from "../../api2";
import { useEffect, useState } from "react";
import { isEmpty } from "lodash";
import { UploadMultiFile as UploadMultiFiles } from "../DanhMuc/Components";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export const FormNhap = ({
  view,
  values,
  errors,
  setFieldValue,
  coSoCheBienList,
  loHangList,
  trangThaiMuaList
}) => {
  return (
    <div>
      <Grid container spacing={1} style={{ marginTop: "0px" }}>
      <Grid item xs={6}>
        <MySelect
            required
            disabled={view}
            label="Lô hàng:"
            placeholder="Chọn..."
            value={values?.loHang}
            options={loHangList || []}
            name="tenLoHang"
            onChange={(event, value) => {
              setFieldValue(`loHang`, value);
            }}
            errors={errors?.tenLoHang}
            helperText={errors?.tenLoHang}
        />
      </Grid>
        <Grid item xs={6}>
          <FastField name="maPhieuMua">
            {({ field }) => (
              <MyTextField
                required
                disabled={view}
                label="Mã phiếu mua:"
                placeholder="Nhập..."
                errors={errors?.maPhieuMua}
                helperText={errors?.maPhieuMua}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="tenHangHoa">
            {({ field }) => (
              <MyTextField
                required
                disabled={view}
                label="Tên hàng hóa:"
                placeholder="Nhập..."
                errors={errors?.tenHangHoa}
                helperText={errors?.tenHangHoa}
                {...field}
              />
            )}
          </FastField>
        </Grid>

        <Grid item xs={6}>
          <MySelectTime
            disabled={view}
            label="Ngày mua:"
            placeholder="Chọn..."
            value={values?.ngayMua}
            onChange={value => {
              setFieldValue(`ngayMua`, value);
            }}
            width="100%"
          />
        </Grid>
        <Grid item xs={6}>
          <MySelect
            disabled={view}
            label="Cơ sở chế biến:"
            placeholder="Chọn..."
            value={values?.coSoCheBien}
            options={coSoCheBienList || []}
            name="tenCoSoCheBien"
            onChange={(event, value) => {
              setFieldValue(`coSoCheBien`, value);
            }}
          />
        </Grid>
        <Grid item xs={6}>
          <FastField name="tenCoSoKhac">
            {({ field }) => (
              <MyTextField
                disabled={view}
                label="Tên cơ sở khác:"
                placeholder="Nhập..."
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <FastField name="soLuong">
            {({ field }) => (
              <MyTextField
                disabled={view}
                label="Số lượng:"
                placeholder="Nhập..."
                type="number"
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={6}>
          <MySelect
            disabled={view}
            label="Trạng thái mua hàng:"
            placeholder="Chọn..."
            value={values?.trangThaiMuaHang}
            options={trangThaiMuaList || []}
            name="ten"
            onChange={(event, value) => {
              setFieldValue(`trangThaiMuaHang`, value);
            }}
          />
        </Grid>
        <Grid item xs={12}>
          <FastField name="ghiChu">
            {({ field }) => (
              <MyTextFieldArea
                disabled={view}
                label="Ghi chú:"
                placeholder="Nhập..."
                maxRows={3}
                {...field}
              />
            )}
          </FastField>
        </Grid>
        <Grid item xs={12} className="fileGiayChungNhan">
          <UploadMultiHinhAnh
            disabled={view}
            multi={true}
            title="Hình ảnh mua hàng:"
            file={values?.hinhAnhs || []}
            handleChangeFile={values => setFieldValue(`hinhAnhs`, values)}
            checkSave={false}
          />
        </Grid>
      </Grid>
    </div>
  );
};
